import { createRoute } from '@tanstack/react-router';
import { requireSession } from '@/app/router/guards';
import { shellRoute } from '@/app/router/routes';
import {
  DocumentCreatePage,
  DocumentDetailPage,
  DocumentsListPage,
  ExecutionDetailPage,
  ExecutionsListPage,
  PlatformExecutionDetailPage,
  RequirementsListPage,
  SigningPage,
} from '@/modules/agreements';

/**
 * The agreements routes.
 *
 * Two surfaces, two authority axes. The subject routes (`/agreements`) are the workspace's
 * own obligations and its signing flow; the platform routes (`/platform/agreements`) are the
 * authoring and ledger surface. The API re-authorizes every call, so these routes are about
 * what the console offers, never about what the server permits.
 */
export const agreementsListRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: '/agreements',
  beforeLoad: requireSession,
  component: function AgreementsListRoute() {
    return <RequirementsListPage />;
  },
});

export const agreementSigningRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: '/agreements/executions/$executionId',
  beforeLoad: requireSession,
  component: function AgreementSigningRoute() {
    const { executionId } = agreementSigningRoute.useParams();
    return <SigningPage executionId={executionId} />;
  },
});

export const agreementExecutionDetailRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: '/agreements/executions/$executionId/record',
  beforeLoad: requireSession,
  component: function AgreementExecutionDetailRoute() {
    const { executionId } = agreementExecutionDetailRoute.useParams();
    return <ExecutionDetailPage executionId={executionId} />;
  },
});

export const platformAgreementDocumentsRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: '/platform/agreements/documents',
  beforeLoad: requireSession,
  component: function PlatformAgreementDocumentsRoute() {
    return <DocumentsListPage />;
  },
});

export const platformAgreementDocumentCreateRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: '/platform/agreements/documents/new',
  beforeLoad: requireSession,
  component: function PlatformAgreementDocumentCreateRoute() {
    return <DocumentCreatePage />;
  },
});

export const platformAgreementDocumentDetailRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: '/platform/agreements/documents/$documentId',
  beforeLoad: requireSession,
  component: function PlatformAgreementDocumentDetailRoute() {
    const { documentId } = platformAgreementDocumentDetailRoute.useParams();
    return <DocumentDetailPage documentId={documentId} />;
  },
});

export const platformAgreementExecutionsRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: '/platform/agreements/executions',
  beforeLoad: requireSession,
  component: function PlatformAgreementExecutionsRoute() {
    return <ExecutionsListPage />;
  },
});

export const platformAgreementExecutionDetailRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: '/platform/agreements/executions/$executionId',
  beforeLoad: requireSession,
  component: function PlatformAgreementExecutionDetailRoute() {
    const { executionId } = platformAgreementExecutionDetailRoute.useParams();
    return <PlatformExecutionDetailPage executionId={executionId} />;
  },
});

export const agreementRoutes = [
  agreementsListRoute,
  agreementSigningRoute,
  agreementExecutionDetailRoute,
  platformAgreementDocumentsRoute,
  platformAgreementDocumentCreateRoute,
  platformAgreementDocumentDetailRoute,
  platformAgreementExecutionsRoute,
  platformAgreementExecutionDetailRoute,
];
